import axios from "~/plugins/axios";

export default {
  all() {
    return axios.get('/web_api/v1/email_footer')
      .then((response) => response.data);
  },
  getByEmailaccountAndUser(emailaccountId, userId) {
    return axios.post('/web_api/v1/email_footer/by_emailaccount_and_user', {
      email_account_id: emailaccountId,
      user_id: userId
    }).then((response) => response.data);
  },
};
